import { useCallback as s, useMemo as r } from "react";
import { v4 as m } from "uuid";
const e = "anonId", c = () => {
  const o = s(() => {
    const n = localStorage.getItem(e);
    if (n)
      return n;
    const t = m();
    return localStorage.setItem(e, t), t;
  }, []);
  return { anonymousId: r(() => o(), [o]), getAnonymousId: o };
};
export {
  c as useAnonymousId
};
